import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Milestone, Badge } from '@app/core/model/activity.model';
import { Response } from '@app/core/model/http.model';

@Injectable()
export class AchievementsService {
    constructor(private httpClient: HttpClient) {}

    // get badge
    getBadge(mId: string, bId: string): Observable<Badge> {
        const params = new HttpParams().set('personaId', mId).set('badgeId', bId);

        return this.httpClient.get<Response>('api/learningpath/badge', { params }).pipe(
            map((res: Response) => {
                return <Badge>res.data;
            }),
        );
    }

    // get milestone
    getMilestone(mId: string): Observable<Milestone> {
        const params = new HttpParams().set('milestoneId', mId);

        return this.httpClient.get<Response>('api/learningpath/milestone', { params }).pipe(
            map((res: Response) => {
                return <Milestone>res.data;
            }),
        );
    }
}
